import {BookingStatusNames} from "app/bookingStatusTypes";
import {BookingType} from "app/app.types";
import {StatusService} from "external-services/status-service";
import ObjectCopyService from "external-services/object-copy-service/index";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import BookingUpdateService from "external-services/booking-update-service/index";
import {BookingCancelledReason, BookingMethods} from "shared-types/index";
import store from "appRoot/Store";
import StatusConfigService from "external-services/status-config-service";

const NS = 'StatusBookingEditorCtrl';

export default function StatusBookingEditorCtrl(
  $scope, $mdDialog, $timeout, booking, schedule
) {
  "ngInject";

  var vm = this;
  var orgBooking = ObjectCopyService.angularSafeCopy(booking);
  vm.changeStatus = changeStatus;


  $scope.$onInit = function () {
    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    vm.statusOptions = statusOptions.filter(status => {
      return StatusService.statusSelectFilter('', status.name, booking.bookingType, booking.paymentDetails);
    });
  };

  /**
   * Saves the status change to the booking
   * @param  {object} status
   */
  function changeStatus(status, message) {
    GeneralSettingsService.get().then(function (settings) {
      const isOldEditSettings = settings.staffEditEnabled && !settings.staffEdit;
      const isNewEditSettings = settings.staffEdit && settings.staffEdit.staffEditQuickEdit;
      if ((isOldEditSettings || isNewEditSettings) && settings.staffEditEnabled && orgBooking.method !== BookingMethods.walkin) {
        var staffNameDialog = $mdDialog.prompt()
          .title('Booking change')
          .placeholder('Staff name')
          .ariaLabel('Staff name')
          .ok('Confirm')
          .cancel('Cancel')
          .clickOutsideToClose(true);

        if (message) {
          staffNameDialog.textContent(message);
        }

        $mdDialog.show(staffNameDialog).then(function (staff) {
          // required check is here because AngularJS Material 1.0.7 doesn't have a 'required' stetting for prompt dialogs
          if (settings.staffEditRequired && !staff) {
            changeStatus(status, 'Staff name required');
          } else {
            update(status, staff);
          }
        });
      } else {
        update(status);
      }
    });
  }

  function update(status, staff) {
    booking.isSaving = true;
    booking.status = status;

    //If booking is being edited, reset cancel reason to default.
    booking.cancelledReason = BookingCancelledReason.unspecified;

    // if manually changed to confirmed or seated, then we force it to a normal bookingType
    if (status.name === BookingStatusNames.Confirmed || status.name === BookingStatusNames.Seated) {
      booking.bookingType = BookingType.Booking;
    }
    booking = BookingUpdateService.updateAfterStatusChange(booking, orgBooking);
    BookingUpdateService.updateFromAnywhere(booking, orgBooking, null, null, staff, schedule).then(function () {
      $mdDialog.hide();
      $timeout(function () {
        delete booking.isSaving;
      }, 1000);


    });
    orgBooking = ObjectCopyService.angularSafeCopy(booking);
  }
}
